import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FeedbackPopup from "../popuplessons/FeedbackPopup";
import ExplanationPopup from "../popuplessons/ExplanationPopup";
import LessonProgress from "../progressbar/StatusProgres";
import CustomAlert from "../progressbar/CustomAlert";
import "./GameTipeAccount.css";

const GameTipeAccount = () => {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [accountType, setAccountType] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  const [explanationText, setExplanationText] = useState("");
  const [answerStatus, setAnswerStatus] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { chapterId, lessonId } = location.state || {};

  // ✅ useEffect trebuie să ruleze mereu
  useEffect(() => {
    if (!chapterId || !lessonId) return; // verificăm aici, în interior

    const fetchQuestions = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/typeaccount/${chapterId}/lesson/${lessonId}`,
          { credentials: "include" }
        );
        const data = await res.json();

        if (data.questions && Array.isArray(data.questions)) {
          setQuestions(data.questions);
        } else {
          console.error("Structura datelor este invalidă.");
        }
      } catch (err) {
        console.error("Eroare la încărcarea întrebărilor:", err);
      }
    };

    fetchQuestions();
  }, []);

  const handleCheck = () => {
    const correct = questions[current];

    if (accountType === correct.correctType) {
      setAnswerStatus("correct");
    } else {
      setAnswerStatus("incorrect");
    }

    setIsChecked(true);
    setShowFeedback(true);
  };

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % questions.length);
    setIsChecked(false);
    setAccountType(null);
    setShowFeedback(false);
    setShowExplanation(false);
  };

  const question = questions[current];
  const progress = Math.round(((current + 1) / questions.length) * 100);

  if (questions.length === 0) return <p>Se încarcă exercițiile...</p>;

  // Handlere pentru alerta de iesire
  const handleExitClick = () => {
    setShowAlert(true);
  };

  const handleConfirmExit = () => {
    setShowAlert(false);
    navigate("/LessonsGameTipeAccount"); // modifică ruta după cum dorești
  };

  const handleCancelExit = () => {
    setShowAlert(false);
  };

  return (
    <div className="type-account-container">
      <div className="type-account-instruction">
        {/* Transmit onExitClick pentru butonul X din StatusProgres */}
        <LessonProgress
          percent={progress}
          onExitClick={handleExitClick}
        />

        <div className="container-game-type-account">
          <p>Selectează tipul contului:</p>
          <div className="type-account-statement">
            <p dangerouslySetInnerHTML={{ __html: question.statement }} />
          </div>

          <div className="type-account-buttons">
            <button
              className={accountType === "Activ" ? "selected" : ""}
              onClick={() => !isChecked && setAccountType("Activ")}
            >
              Activ
            </button>
            <button
              className={accountType === "Pasiv" ? "selected" : ""}
              onClick={() => !isChecked && setAccountType("Pasiv")}
            >
              Pasiv
            </button>
          </div>
        </div>

        <div className="type-account-check">
          {!isChecked ? (
            <button
              className={`type-account-verify ${!accountType ? "disabled" : ""}`}
              onClick={handleCheck}
              disabled={!accountType}
            >
              Verifica
            </button>
          ) : (
            <button className="type-account-verify" onClick={handleNext}>
              {current + 1 < questions.length ? "Continua" : "Continua"}
            </button>
          )}
        </div>
      </div>

      {showFeedback && (
        <FeedbackPopup
          status={answerStatus}
          onClose={() => setShowFeedback(false)}
          onContinue={handleNext}
          onShowAnswer={() => {
            setShowFeedback(false);
            setExplanationText(question.explanation || "Explicație indisponibilă.");
            setShowExplanation(true);
          }}
        />
      )}

      {showExplanation && (
        <ExplanationPopup
          explanation={explanationText}
          onContinue={() => setShowExplanation(false)}
        />
      )}

      {/* CustomAlert pentru confirmare iesire */}
      {showAlert && (
        <CustomAlert
          onConfirm={handleConfirmExit}
          onCancel={handleCancelExit}
        />
      )}
    </div>
  );
};

export default GameTipeAccount;
